import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';

import { PackageDateSidebar_packageDate$key } from '__generated__/PackageDateSidebar_packageDate.graphql';

type Props = {
  packageDate: PackageDateSidebar_packageDate$key;
};

const PackageDateSidebar: FC<Props> = props => {
  const packageDate = useFragment(
    graphql`
      fragment PackageDateSidebar_packageDate on PackageDate {
        start
        end

        package {
          id
          name
        }

        ...EntitySidebar_entity
      }
    `,
    props.packageDate
  );

  const { start, end } = packageDate;

  return (
    <EntitySidebar entity={packageDate}>
      <SidebarBox icon={BeachAccessIcon}>
        <Link href={`/packages/${packageDate.package.id}#dates`}>
          {packageDate.package.name}
        </Link>
      </SidebarBox>

      <Divider />

      <SidebarBox label="Kelionės pradžia">{start}</SidebarBox>

      <Divider />

      <SidebarBox label="Kelionės pabaiga">{end}</SidebarBox>
    </EntitySidebar>
  );
};

export default PackageDateSidebar;
